import { NoteEventTime } from "@spotify/basic-pitch";

export enum WorkerMessageType {
  AudioBuffer = 'audioBuffer',
  InitMsg = 'initMsg',
  SetTranscriptionParams = 'setTranscriptionParams',
}

interface MessageData {}

export interface MessageEvent {
  type: WorkerMessageType;
  data: MessageData;
}

export interface SetTranscriptionParamsMessage extends MessageData {
  onsetThresh: number;
  frameThresh: number;
  minNoteLen: number;
  inferOnsets: boolean;
  maxFreq: number;
  minFreq: number;
  melodiaTrick: boolean;
}

export interface AudioBuffer extends MessageData {
  midiArray: NoteEventTime[];
  performanceLogs: Object;
}

export interface InitMsg extends MessageData {
  isReady: Boolean;
}